import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { checkKYC } from '../redux-store/actions/newPurchase';
import { RootStateType } from '../redux-store/reducers';
import { GET_KYC_VERIFIED } from '../redux-store/types/portfolio';

const useKYCResponse = ({ callApi }: { callApi: boolean }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { kycVerified, loading } = useSelector(({ newPurchase }: RootStateType) => ({
        kycVerified: newPurchase.kycVerified,
        loading: newPurchase.apiPendingActions.includes(GET_KYC_VERIFIED),
    }));

    useEffect(() => {
        async function fetchKYCStatus() {
            //[FIX] type
            try {
                await dispatch(
                    checkKYC({
                        jh1Pan: '',
                        jh2Pan: '',
                        amc: '',
                        reqId: '12345',
                    }),
                );
            } catch (err: any) {
                alert(err.message);
                history.goBack();
            }
        }
        if (callApi) {
            if (kycVerified.value === null) fetchKYCStatus();
        }
    }, []);

    return { kycVerified, loading };
};

export default useKYCResponse;
